import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function Footer() {
  const year = new Date().getFullYear();
  const navigate = useNavigate();

  // Navigate to page AND scroll to top
  const goTo = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const AMBER = '#F5A800';

  const NavLink = ({ to, children, ext }) => {
    const style = {
      display: 'block',
      color: '#888',
      fontSize: '0.85rem',
      marginBottom: '0.7rem',
      transition: 'color 0.2s',
      cursor: 'pointer',
      textDecoration: 'none',
    };
    if (ext) return (
      <a href={to} target="_blank" rel="noopener noreferrer" style={style}
        onMouseEnter={e => e.target.style.color = AMBER}
        onMouseLeave={e => e.target.style.color = '#888'}>
        {children}
      </a>
    );
    return (
      <span style={style}
        onClick={() => goTo(to)}
        onMouseEnter={e => e.target.style.color = AMBER}
        onMouseLeave={e => e.target.style.color = '#888'}>
        {children}
      </span>
    );
  };

  const ColTitle = ({ children }) => (
    <p style={{
      fontSize: '0.65rem', letterSpacing: '0.2em',
      textTransform: 'uppercase', color: AMBER,
      marginBottom: '1.2rem', fontWeight: '700',
    }}>{children}</p>
  );

  const SocialBtn = ({ href, label, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
      style={{
        width: '40px', height: '40px', borderRadius: '10px',
        background: AMBER, display: 'flex', alignItems: 'center',
        justifyContent: 'center', transition: 'all 0.3s', flexShrink: 0,
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(245,168,0,0.4)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}>
      {children}
    </a>
  );

  return (
    <footer style={{ background: '#000', borderTop: '1px solid rgba(245,168,0,0.12)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 1.5rem 2rem' }}>

        {/* ── GRID ─────────────────────────────────────────────────── */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
          gap: '2.5rem',
        }}>

          {/* Brand column */}
          <div style={{ gridColumn: 'span 1' }}>
            <span onClick={() => goTo('/')} style={{ cursor: 'pointer', display: 'inline-block', marginBottom: '1rem' }}>
              <img src={logo} alt="Wedoo Interiors" loading="lazy" decoding="async" width="200" height="60" style={{ height: '60px', width: 'auto', maxWidth: '200px', objectFit: 'contain' }} />
            </span>
            <p style={{ color: '#888', fontSize: '0.82rem', lineHeight: '1.8', marginBottom: '1.5rem' }}>
              Premium interior design studio in Tumakuru, Karnataka. Transforming homes into extraordinary living spaces.
            </p>
            {/* Social icons */}
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              <SocialBtn href="https://facebook.com/wedoointeriors" label="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#000"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
              </SocialBtn>
              <SocialBtn href="https://www.instagram.com/wedoo_interiors/" label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2.2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="#000" stroke="none"/></svg>
              </SocialBtn>
              <SocialBtn href="https://youtube.com/@wedoointeriors" label="YouTube">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#000"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.54C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg>
              </SocialBtn>
              <SocialBtn href="https://linkedin.com/company/wedoointeriors" label="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#000"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
              </SocialBtn>
            </div>
          </div>

          {/* Services */}
          <div>
            <ColTitle>Services</ColTitle>
            <NavLink to="/services/complete-modular-site-work">Complete Modular</NavLink>
            <NavLink to="/services/interior-design">Interior Design</NavLink>
            <NavLink to="/services/home-lighting">Home Lighting</NavLink>
            <NavLink to="/services/modular-kitchen">Modular Kitchen</NavLink>
            <NavLink to="/services/false-ceiling-painting">False Ceiling</NavLink>
            <NavLink to="/services/aluminium-glass-works">Aluminium & Glass</NavLink>
          </div>

          {/* Company */}
          <div>
            <ColTitle>Company</ColTitle>
            <NavLink to="/about">About Us</NavLink>
            <NavLink to="/portfolio">Portfolio</NavLink>
            <NavLink to="/blog">Blog</NavLink>
            <NavLink to="/reviews">Reviews</NavLink>
            <NavLink to="/faq">FAQ</NavLink>
            <NavLink to="/careers">Careers</NavLink>
          </div>

          {/* Legal */}
          <div>
            <ColTitle>Legal</ColTitle>
            <NavLink to="/privacy-policy">Privacy Policy</NavLink>
            <NavLink to="/terms-and-conditions">Terms & Conditions</NavLink>
            <NavLink to="/sitemap">Sitemap</NavLink>
            <NavLink to="/get-free-quote">Get Free Quote</NavLink>
          </div>

          {/* Contact */}
          <div>
            <ColTitle>Contact Us</ColTitle>
            <p style={{ color: '#888', fontSize: '0.82rem', lineHeight: '1.9', marginBottom: '1rem' }}>
             #1, Near Muneshwara Temple,<br />
              Manjunath Nagar, Gokula Extension,<br />
              Tumakuru, Karnataka 572104
            </p>
            <a href="tel:+919686583195"
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: AMBER, fontSize: '0.88rem', marginBottom: '0.6rem', textDecoration: 'none' }}>
              📞 +91 96865 83195
            </a>
            <a href="https://api.whatsapp.com/send?phone=919686583195&text=Hi%20Wedoo%20Interiors%2C%20I%20am%20interested%20in%20your%20services."
              target="_blank" rel="noopener noreferrer"
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#25D366', fontSize: '0.82rem', marginBottom: '0.6rem', textDecoration: 'none' }}>
              💬 WhatsApp Chat
            </a>
            <a href="https://www.instagram.com/wedoo_interiors/" target="_blank" rel="noopener noreferrer"
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#E1306C', fontSize: '0.82rem', textDecoration: 'none' }}>
              📷 @wedoo_interiors
            </a>
          </div>
        </div>

        {/* Divider */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', marginTop: '3rem', paddingTop: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
          <p style={{ color:'var(--muted)', fontSize: '0.72rem' }}>
            © {year} Wedoo Interiors. All rights reserved. | Interiors
          </p>
          <p style={{ color:'var(--muted)', fontSize: '0.7rem' }}>
            Best Interior Designers in Tumakuru, Karnataka
          </p>
        </div>

        {/* Developer credit */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', marginTop: '1.25rem', paddingTop: '1.1rem', textAlign: 'center' }}>
          <p style={{ color:'var(--muted)', fontSize: '0.7rem', letterSpacing: '0.04em' }}>
            Developed by{' '}
            <a href="http://techbsoftwaresolutions.com/" target="_blank" rel="noopener noreferrer"
              style={{ color: '#8a8278', borderBottom: '1px solid rgba(245,168,0,0.35)', paddingBottom: '1px', transition: 'color 0.25s' }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--gold)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = '#8a8278'; }}>
              Techb Software Solutions Pvt Ltd
            </a>
          </p>
        </div>
      </div>

      {/* ── Responsive styles ──────────────────────────────────────── */}
      <style>{`
        footer a { text-decoration: none !important; }

        /* Mobile: 2 columns */
        @media (max-width: 768px) {
          footer > div > div:first-child {
            grid-template-columns: 1fr 1fr !important;
          }
          footer > div > div:first-child > div:first-child {
            grid-column: span 2 !important;
          }
        }

        /* Very small mobile: 1 column */
        @media (max-width: 420px) {
          footer > div > div:first-child {
            grid-template-columns: 1fr !important;
          }
          footer > div > div:first-child > div:first-child {
            grid-column: span 1 !important;
          }
        }
      `}</style>
    </footer>
  );
}